import '../banners.less';
import './index.less';

import { Col, Row } from 'antd';
import React from 'react';
import Fade from 'react-reveal/Fade';

import Title from '../../BannerShared/Title';
import FranchiseMap from '../../FranchiseMap';

const Covid = () => (
  <div className="banner-globalexpansion">
    <div className="container">
      <Row justify="center">
        <Col xs={24} sm={24} md={24} lg={18} xl={16}>
          <Fade>
            <section style={{ textAlign: 'center' }}>
              <Title title="Global Expansion" isTagline isCenter />
              <Title
                title="We Are Growing"
                description="Ritual目前已在全球多个国家为健身场景提供服务，包括中国、新加坡、美国、瑞士、巴西等。"
                style={{ marginBottom: '50px' }}
              />
            </section>
          </Fade>
        </Col>
      </Row>

      <Row justify="center">
        <Col span={24}>
          <FranchiseMap />
        </Col>
      </Row>
      {/* <div className="buttons-container" style={{ textAlign: 'center', marginTop: '60px' }}>
          <a href="#franchise-form-anchor">
            <Button type="button">{t(`franchise_globalexpansion_button`).toLowerCase()}</Button>
          </a>
        </div> */}
    </div>
  </div>
);

export default Covid;
